import { useTranslation } from "react-i18next";
import { convertDate } from "../../services/luxonHelper";
import css from "./Reviews.module.css";

import UserNameTagComponent from "../../cubeComponent/html/UserNameTagComponent";

function ReviewBasicDetails({
  workflowName,
  createdBy,
  currentReviewLevelSerial,
  currentReviewLevelTitle,
  nextActionDueDate,
  createdDate,
  finishedDate,
  numberOfEntitiesAttached,
}) {
  const { t } = useTranslation();
  const getFormattedDate = (date) => {
    if (date) {
      return convertDate(Number(date), "dateForText");
    }

    return "-";
  };

  const getUserAvatarComponent = (user) => <UserNameTagComponent id={user.userId} />;

  return (
    <div className={css.accordianContent}>
      <div className={css.detail}>
        <span className={css.detailName}>{t("Review Flow Name")}</span>
        <div className={css.reviewDetailValue}>
          <span>{workflowName}</span>
        </div>
      </div>

      <div className={css.detail}>
        <span className={css.detailName}>{t("Created by")}</span>
        <div className={css.reviewDetailValue}>
          <span
            className="text-[var(--size-16)] font-semibold flex-1 overflow-hidden text-ellipsis whitespace-nowrap cursor-pointer"
            data-testid="userProfileDetail"
          >
            {getUserAvatarComponent(createdBy)}
          </span>
        </div>
      </div>

      <div className={css.detail}>
        <span className={css.detailName}>{t("Waiting For")}</span>
        <div className={css.reviewDetailValue}>
          <span>
            {currentReviewLevelSerial && currentReviewLevelTitle
              ? `${currentReviewLevelSerial} - ${currentReviewLevelTitle}`
              : "-"}
          </span>
        </div>
      </div>

      <div className={css.detail}>
        <span className={css.detailName}>{t("Next Action Due")}</span>
        <div className={css.reviewDetailValue}>
          <span>{getFormattedDate(nextActionDueDate)}</span>
        </div>
      </div>

      <div className={css.detail}>
        <span className={css.detailName}>{t("Created On")}</span>
        <div className={css.reviewDetailValue}>
          <span>{getFormattedDate(createdDate)}</span>
        </div>
      </div>

      <div className={css.detail}>
        <span className={css.detailName}>{t("Finished On")}</span>
        <div className={css.reviewDetailValue}>
          <span>{getFormattedDate(finishedDate)}</span>
        </div>
      </div>

      <div className={css.detail}>
        <span className={css.detailName}>{t("Contents")}</span>
        <div className={css.reviewDetailValue}>
          <span>{numberOfEntitiesAttached}</span>
        </div>
      </div>
    </div>
  );
}

export default ReviewBasicDetails;
